import { IVerticalMenuState } from './verticalMenuState';

export default {
  UPDATE_VERTICAL_MENU_COLLAPSED( state: IVerticalMenuState, val: boolean ) {
    state.isVerticalMenuCollapsed = val
  },
};
